import { GlobalClassInstance } from "@commoncore/constants/GlobalClass";
import { TOAST } from "@commoncore/constants/ToastMessages";
import { Controller } from "@commoncore/controller/Controller";
import { ShareObjectsImplementation } from "@commoncore/implementation/ShareObjectsImplementation";
import { ENV_CONSTANTS } from "@env-properties/environment";
import { ENV_CONFIG } from "@env-properties/environment-config";
import { EnterpriseImplementation } from "../implementation/EnterpriseImplementation";

export class EnterpriseController extends Controller{
    public dashboardImplementation:any;
    public universalService:any;
    public static singleInstance:any = null
    public router:any;
    public http:any;
    public globalService: any;
    loggerService: any;
    shareObjectsImplementation: any;
    cleverTapEventsService:any;

    public constructor(globalService) {
      super(globalService);
      this.dashboardImplementation= EnterpriseImplementation.getInstance(globalService);
      this.shareObjectsImplementation = ShareObjectsImplementation.getInstance(globalService);
      this.cleverTapEventsService =  globalService.getCleverTapEventsvc();
    }
    
    public static getInstance(globalService):EnterpriseController{
		if(this.singleInstance == null){
			this.singleInstance = new EnterpriseController(globalService);
			return this.singleInstance;
		}else{
			return this.singleInstance;
		}
	}

  public setEnvObjects(globalService){
    this.globalService= globalService
    this.universalService=globalService.getUniversalServiceRef();
    this.router = globalService.getRouterRef();
    this.http = globalService.getHttpClientRef();
    this.loggerService = globalService.getLoggerServiceRef();
  }

  async getDataUsageGraph(duration, durationType) {

    var url  = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["admncURL"] + ENV_CONFIG.commonUrls["enterpriseApiURL"] + ENV_CONFIG.commonUrls["dataUsage"] + "?duration="+duration+"&durationType="+durationType;
    this.dashboardImplementation.setHandler(this.globalService);
    try {
      var val = await this.dashboardImplementation.getDataUsageGraph(url);
      return val;
    }catch(exception){
      console.log("exception in fetching dashboard usage",exception);
      return null;
    } finally{
      this.universalService.showLoader = false;   
    }
  }


  async getSearchedUserData(searchParam, searchSource) { 
    var url  = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["admncURL"] + ENV_CONFIG.commonUrls["enterpriseApiURL"] + ENV_CONFIG.commonUrls["entSearchUser"] + "?name="+searchParam;
    if(this.router.url.includes('/teamfolder') && searchSource != "share"){
      url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["admncURL"] + ENV_CONFIG.commonUrls["enterpriseApiURL"] + ENV_CONFIG.commonUrls["entTeamFolderSearchUser"] + "?name="+searchParam;
    }
    this.dashboardImplementation.setHandler(this.globalService);
    try {
      var val = await this.dashboardImplementation.getSearchedUserData(url);
      return val;
    }catch(exception){
      console.log("exception in fetching search result.",exception);
      return null;
    } finally{
      this.universalService.showLoader = false;   
    }
  }

  async getSearchedGroupData(searchParam) {
    var url  = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["admncURL"] + ENV_CONFIG.commonUrls["enterpriseApiURL"] + ENV_CONFIG.commonUrls["entSearchGroup"] + "?groupName="+searchParam;
    this.dashboardImplementation.setHandler(this.globalService);
    try {
      var val = await this.dashboardImplementation.getSearchedGroupData(url);
      return val;
    }catch(exception){
      console.log("exception in fetching group search result.",exception)
      return null;
    } finally{
      this.universalService.showLoader = false;   
    }
  }


  async getSearchedUserByEmail(searchParam) { 

    var url  = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["admncURL"] + ENV_CONFIG.commonUrls["enterpriseApiURL"] + ENV_CONFIG.commonUrls["entSearchUser"] + ENV_CONFIG.commonUrls["entSearchByEmail"] + "?emailId="+searchParam;
    this.dashboardImplementation.setHandler(this.globalService);
    try {
      var val = await this.dashboardImplementation.getSearchedUserDataByEmail(url);
      return val;
    }catch(exception){
      console.log("exception in fetching search result.",exception);
      return null;
    } finally{
      this.universalService.showLoader = false;   
    }
  }

  /**
  * Get all the team folders list
  */
   async getTeamFoldersListData(link) {
    this.universalService.showLoader= true;
    // let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["tmfldURL"] + ENV_CONFIG.commonUrls["tmfld"] + ENV_CONFIG.commonUrls["tmfldlist"] + "?sort=+lastUpdatedDate";
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["tmfldURL"];
    if(link == undefined) {
      url = url + ENV_CONFIG.commonUrls["tfPortal"] + ENV_CONFIG.commonUrls["tflist"] + "?sort=-lastUpdatedDate&limit="+this.dashboardImplementation.tfListItemsPerPage;
    } else {
      url = url + link;
    }
    this.dashboardImplementation.setHandler(this.globalService);
    try {
      var result = await this.dashboardImplementation.getListData(url);
      return result;
    } catch (exc) {
      this.universalService.showLoader= false;
      this.loggerService.log("exception handled for Usr List", exc);
      return null;
    }
  }

  /**
  * Create team folder
  */
   async createTeamFolder(payload) {
    this.universalService.showLoader= true;
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["tmfldURL"] + ENV_CONFIG.commonUrls["tfPortal"] + ENV_CONFIG.commonUrls["tfCreate"];
    this.dashboardImplementation.setHandler(this.globalService);
    try {
      var result = await this.dashboardImplementation.createTeamFolder(url, payload);
      this.cleverTapEventsService.createTF();
      return result;
    } catch (exc) {
      this.universalService.showLoader= false;
      this.loggerService.log("exception handled for create team folder", exc);
      return null;
    }
  }

  /**
  * Duplicate team folder
  */
   async tfDuplicate(tfKey, objectKey){
    this.universalService.showLoader= true;
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["tmfldURL"] + ENV_CONFIG.commonUrls["tfPortal"] + ENV_CONFIG.commonUrls["tfDuplicate"];
    let param = {
      "tfKey" : tfKey,
      "objectKey" : objectKey
    }
    try {
      var result = await this.dashboardImplementation.tfDuplicate(url,param);
      return result;
    } catch (exc) {
      this.universalService.showLoader= false;
      return null;
    }
  }

  /**
  * Delete team folder
  */
  async tfDelete(tfKey, objectKey, tfName){
    this.universalService.showLoader= true;
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["tmfldURL"] + ENV_CONFIG.commonUrls["tfPortal"] + ENV_CONFIG.commonUrls["tfDelete"];
    let param = {
      "tfKey" : tfKey,
      "objectKey" : objectKey
    }
    try {
      this.cleverTapEventsService.tfDelete();
      var result = await this.dashboardImplementation.tfDelete(url,param,tfName);
      return result;
    } catch (exc) {
      this.universalService.showLoader= false;
      return null;
    }
  }

  /**
  * Restore team folder
  */
   async tfRestore(tfKey, objectKey){
    this.universalService.showLoader= true;
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["tmfldURL"] + ENV_CONFIG.commonUrls["tfPortal"] + ENV_CONFIG.commonUrls["tfRestore"];
    let param = {
      "tfKey" : tfKey,
      "objectKey" : objectKey
    }
    try {
      var result = await this.dashboardImplementation.tfRestore(url,param);
      return result;
    } catch (exc) {
      this.universalService.showLoader= false;
      return null;
    }
  }

 
  /**
  * Get all the user list on object
  */
  async getUserListData(userType,pageNo=1) {
    this.universalService.showLoader= true;
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["admncURL"] + ENV_CONFIG.commonUrls["enterpriseApiURL"] + ENV_CONFIG.commonUrls["entUsers"] + "?page=" +  pageNo + "&pageSize=50";
    if(userType == "I" || userType == "P")
      url = url+"&userType="+userType
    this.dashboardImplementation.setHandler(this.globalService);
    try {
      var result = await this.dashboardImplementation.getListData(url);
      return result;
    } catch (exc) {
      this.universalService.showLoader= false;
      this.loggerService.log("exception handled for Usr List", exc);
      return null;
    }
  }

  async getGroupsListData(pageNo=1) {
    this.universalService.showLoader= true;
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["admncURL"] + ENV_CONFIG.commonUrls["enterpriseApiURL"] + ENV_CONFIG.commonUrls["fetchEntGroups"] + "?page=" +  pageNo + "&pageSize=50";
    this.dashboardImplementation.setHandler(this.globalService);
    try {
      var result = await this.dashboardImplementation.getListData(url);
      return result;
    } catch (exc) {
      this.universalService.showLoader= false;
      this.loggerService.log("exception handled for Usr List", exc);
      return null;
    }
  }

  /*async getPendingData(){
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["admncURL"] + ENV_CONFIG.commonUrls["enterpriseApiURL"] + ENV_CONFIG.commonUrls["entUsers"];
    url = url+"?userType=P";
    this.dashboardImplementation.setHandler(this.globalService);
    try {
      var result = await this.dashboardImplementation.getPendingData(url);
      return result;
    } catch (exc) {
      this.loggerService.log("exception handled for Usr List", exc);
      return null;
    }
  }*/
  async getActivityEventsMaster() {
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["admncURL"] + ENV_CONFIG.commonUrls["enterpriseApiURL"] + ENV_CONFIG.commonUrls["entEvents"];
    this.dashboardImplementation.setHandler(this.globalService);
    try {
      var result = await this.dashboardImplementation.getActivityEventsMaster(url);
      return result;
    } catch (exc) {
      this.loggerService.log("exception handled for events", exc);
      return null;
    }
  }

  async getActivityLogs(payload,direction,offset,daysCount) {
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["admncURL"] + ENV_CONFIG.commonUrls["enterpriseApiURL"] + ENV_CONFIG.commonUrls["entActivityData"];
    url = url +"?direction="+direction+"&offset="+offset+"&limit="+this.dashboardImplementation.reportItemsPerPage+"&timezone="+this.dashboardImplementation.timezone;
    if(daysCount>-1)
      url = url +"&lastNDays="+daysCount
    this.dashboardImplementation.setHandler(this.globalService);
    try {
      var result = await this.dashboardImplementation.getActivityLogs(url, payload);
      return result;
    } catch (exc) {
      this.loggerService.log("exception handled for events", exc);
      return null;
    }
  }

  async addEntUser(payload) {
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["admncURL"] + ENV_CONFIG.commonUrls["enterpriseApiURL"] + ENV_CONFIG.commonUrls["addEntUser"];
    this.dashboardImplementation.setHandler(this.globalService);
    try {
      var result = await this.dashboardImplementation.addEntUser(url, payload);
      return result;
    } catch (exc) {
      this.loggerService.log("exception handled for add User", exc);
      return exc;
    }
  }
  async updateUserDetails(payload){
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["admncURL"] + ENV_CONFIG.commonUrls["enterpriseApiURL"] + ENV_CONFIG.commonUrls["entUser"];
    this.dashboardImplementation.setHandler(this.globalService);
    try {
      var result = await this.dashboardImplementation.updateUserDetails(url,payload);
      return result;
    } catch (exc) {
      this.loggerService.log("exception handled for deleteInvite", exc);
      return exc;
    }
  }

  async deleteInvite(user){
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["admncURL"] + ENV_CONFIG.commonUrls["enterpriseApiURL"] + ENV_CONFIG.commonUrls["entUser"];
    url = url+"?accountId="+user.accountId;
    this.dashboardImplementation.setHandler(this.globalService);
    try {
     await this.dashboardImplementation.deleteUser(url,user);
    } catch (exc) {
      this.loggerService.log("exception handled for deleteInvite", exc);
    }
  }

  async deleteUser(user){
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["admncURL"] + ENV_CONFIG.commonUrls["enterpriseApiURL"] + ENV_CONFIG.commonUrls["entUser"];
    url = url+"?accountId="+user.accountId;
    this.dashboardImplementation.setHandler(this.globalService);
    try {
     await this.dashboardImplementation.deleteUser(url,user);
    } catch (exc) {
      this.loggerService.log("exception handled for deleteInvite", exc);
    }
  }

  async disableUser(user){
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["admncURL"] + ENV_CONFIG.commonUrls["enterpriseApiURL"] + ENV_CONFIG.commonUrls["entUserdeactivate"];
    this.dashboardImplementation.setHandler(this.globalService);
    try {
      var payload = {
        "accountId":user.accountId
    }
     await this.dashboardImplementation.disableUser(url,payload,user);
    } catch (exc) {
      this.loggerService.log("exception handled for deleteInvite", exc);
    }
  }
/*
  async getInactiveUsers(){
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["admncURL"] + ENV_CONFIG.commonUrls["enterpriseApiURL"] + ENV_CONFIG.commonUrls["entUsers"];
    url = url+"?userType=I";
    this.dashboardImplementation.setHandler(this.globalService);
    try {
      var result = await this.dashboardImplementation.getPendingData(url);
      return result;
    } catch (exc) {
      this.loggerService.log("exception handled for Usr List", exc);
      return null;
    }
  }*/

  async enableUser(user){
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["admncURL"] + ENV_CONFIG.commonUrls["enterpriseApiURL"] + ENV_CONFIG.commonUrls["entUseractivate"];
    this.dashboardImplementation.setHandler(this.globalService);
    try {
      var payload = {
        "accountId":user.accountId
    }
     await this.dashboardImplementation.enableUser(url,payload,user);
    } catch (exc) {
      this.loggerService.log("exception handled for deleteInvite", exc);
    }
  }

  async getActivityReport(payload,type,daysCount){
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["admncURL"] + ENV_CONFIG.commonUrls["enterpriseApiURL"] + ENV_CONFIG.commonUrls["getReport"];
    url = url+"?type="+type
    if(daysCount>-1)
      url = url +"&lastNDays="+daysCount
    url = url +"&timezone="+this.dashboardImplementation.timezone;
    this.dashboardImplementation.setHandler(this.globalService);
    try {
      var result = await this.dashboardImplementation.getActivityReport(url,payload,type);
      return result;
    } catch (exc) {
      this.loggerService.log("exception handled for deleteInvite", exc);
      return exc;
    }
  }

  async updateEntSettingsShare(payload){
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["admncURL"] + ENV_CONFIG.commonUrls["enterpriseApiURL"] + ENV_CONFIG.commonUrls["updateShareSetting"];
    this.dashboardImplementation.setHandler(this.globalService);
    try {
      var result = await this.dashboardImplementation.updateEntSettingsShare(url,payload);
      return result;
    } catch (exc) {
      this.loggerService.log("exception handled for updateEntSettingsShare", exc);
      return exc;
    }
  }

  async updateEntSettingsTFQuota(payload){
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["admncURL"] + ENV_CONFIG.commonUrls["enterpriseApiURL"] + ENV_CONFIG.commonUrls["teamFolderEntQuota"] + ENV_CONFIG.commonUrls["teamFolderEntQuotaUpdate"];
    this.dashboardImplementation.setHandler(this.globalService);
    try {
      var result = await this.dashboardImplementation.updateEntSettingsTFQuota(url, payload);
      return result;
    } catch (exc) {
      this.loggerService.log("exception handled for updateEntSettingsTFQuota", exc);
      return exc;
    }
  }

  async uploadCSV(file){
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["admncURL"] + ENV_CONFIG.commonUrls["enterpriseApiURL"] + ENV_CONFIG.commonUrls["csvUpload"];
    this.dashboardImplementation.setHandler(this.globalService);
    try {
      await this.dashboardImplementation.uploadCSV(url,file);
    } catch (exc) {
      this.loggerService.log("exception handled for deleteInvite", exc);
      return exc;
    }
  }

  async deletePublicLink(shareKey){
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["shareURL"] +  ENV_CONFIG.commonUrls["publicDeleteShareLink"];
    url = url.replace('_sharekey',shareKey)
    this.dashboardImplementation.setHandler(this.globalService);
    try {
      await this.dashboardImplementation.deletePublicLink(url);
      this.universalService.showToast(TOAST["LINK_DELETED_SUCCESS"],"success");

    } catch (exc) {
      this.loggerService.log("exception handled for deletePublicLink", exc);
      return exc;
    }
  }

  async deleteAllPublicLink(user){
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["shareURL"] +  ENV_CONFIG.commonUrls["publicDeleteAllShareLink"];
    this.dashboardImplementation.setHandler(this.globalService);
    try {
      var payload = {
        "userId":user.actorUserId
      }
      await this.dashboardImplementation.deleteAllLink(url,payload);
      this.universalService.showToast('All links created by '+user.emailId+' deleted successfully',"success");

    } catch (exc) {
      this.loggerService.log("exception handled for deleteAllPublicLink", exc);
      return exc;
    }
  }

  async disableAllAccess(userId,shareKey){
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] +  ENV_CONFIG.commonUrls["privateDeleteShare"];
    this.dashboardImplementation.setHandler(this.globalService);
    try {
      var payload = {
        "userId":userId,
        "shareKey":shareKey
      }
      await this.dashboardImplementation.deleteAllLink(url,payload);
      this.universalService.showToast(TOAST["FILE_FOLDER_ACCESS_MODIFIED"],"success");

    } catch (exc) {
      this.loggerService.log("exception handled for deleteAllPublicLink", exc);
      return exc;
    }
  }

  async getEntNotifications(link?){
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["notificationsURL"];
    url = link ? url+link : url + ENV_CONFIG.commonUrls["entNotifications"] + "?limit=20"
    this.dashboardImplementation.setHandler(this.globalService);
    try {
      var result = await this.dashboardImplementation.getEntNotifications(url);
      return {"suc":result};
    } catch (exc) {
      this.loggerService.log("exception handled for getEnterpriseNotifications", exc);
      return {"error":exc};
    }
  }

  onScrollDown(allNotifBottom,notifsHolderBottom){ 
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["admncURL"] + this.dashboardImplementation.entNotifsNextLink;
    try{
      this.dashboardImplementation.createUrlForNextLink(allNotifBottom,notifsHolderBottom,url);
    }
    catch(exc){
      console.log("exception in scroll down",exc);
    }
  }

  async getExternalSharingActivity(offset) {
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["admncURL"] + ENV_CONFIG.commonUrls["enterpriseApiURL"] + ENV_CONFIG.commonUrls["sharehistory"];
    url = url +"?offset="+offset+"&limit="+this.dashboardImplementation.externalSharingItemsPerPage;
    this.dashboardImplementation.setHandler(this.globalService);
    try {
      var result = await this.dashboardImplementation.getExternalSharingActivity(url);
      return result;
    } catch (exc) {
      this.loggerService.log("exception handled for events", exc);
      return null;
    }
  }

  async updateCollabShareForSelectedObjects(payload) {
  var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["admncURL"] + ENV_CONFIG.commonUrls["nmsCollabShare"];
    this.shareObjectsImplementation.setHandler(this.globalService)
    try {
      var result = await this.shareObjectsImplementation.updateCollabShareLink(url, payload);
      return result;
    } catch (exc) {
      this.loggerService.log("exception handled for creating share link", exc);
      return exc;
    }
  }

  closeNotificationModal(){
    this.universalService.showEntNotifications = false;
    this.dashboardImplementation.entNotifsNextLink = null;
    this.dashboardImplementation.entNotifsPreviousLink = null;
  }

  async createNewGroup(payload){
    this.universalService.showLoader= true;
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["admncURL"] + ENV_CONFIG.commonUrls["enterpriseApiURL"] + ENV_CONFIG.commonUrls["createEntGroup"];
    try {
      var result = await this.dashboardImplementation.createNewGroup(url,payload);
      return result;
    } catch (exc) {
      this.universalService.showLoader= false;
      return null;
    }
  }

  async addMembersGroup(payload){
    this.universalService.showLoader= true;
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["admncURL"] + ENV_CONFIG.commonUrls["enterpriseApiURL"] + ENV_CONFIG.commonUrls["addMembersEntGroup"];
    try {
      var result = await this.dashboardImplementation.addMembersGroup(url,payload);
      return result;
    } catch (exc) {
      this.universalService.showLoader= false;
      return null;
    }
  }

  async deleteMembersGroup(payload){
    this.universalService.showLoader= true;
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["admncURL"] + ENV_CONFIG.commonUrls["enterpriseApiURL"] + ENV_CONFIG.commonUrls["deleteMembersEntGroup"];
    try {
      var result = await this.dashboardImplementation.deleteMembersGroup(url,payload);
      return result;
    } catch (exc) {
      this.universalService.showLoader= false;
      return null;
    }
  }

  async getMembersGroup(groupKey){
    this.universalService.showLoader= true;
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["admncURL"] + ENV_CONFIG.commonUrls["enterpriseApiURL"] + ENV_CONFIG.commonUrls["getEntGroupMembers"];
    let param = {"groupKey" : groupKey}
    try {
      var result = await this.dashboardImplementation.getMembersGroup(url,param);
      return result;
    } catch (exc) {
      this.universalService.showLoader= false;
      return null;
    }
  }

  async renameGroup(payload){
    this.universalService.showLoader= true;
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["admncURL"] + ENV_CONFIG.commonUrls["enterpriseApiURL"] + ENV_CONFIG.commonUrls["renameEntGroup"];
    try {
      var result = await this.dashboardImplementation.renameGroup(url,payload);
      return result;
    } catch (exc) {
      this.universalService.showLoader= false;
      return null;
    }
  }

  async deleteGroup(groupKey,grpName){
    this.universalService.showLoader= true;
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["admncURL"] + ENV_CONFIG.commonUrls["enterpriseApiURL"] + ENV_CONFIG.commonUrls["deleteEntGroup"];
    let param = {"groupKey" : groupKey}
    try {
      var result = await this.dashboardImplementation.deleteGroup(url,param,grpName);
      return result;
    } catch (exc) {
      this.universalService.showLoader= false;
      return null;
    }
  }

  async getSearchedAll(searchParam,tabName) { 

    var url  = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["admncURL"] + ENV_CONFIG.commonUrls["entSearchAll"]+searchParam;
    this.dashboardImplementation.setHandler(this.globalService);
    try {
      var val = await this.dashboardImplementation.getSearchedAll(url,tabName);
      return val;
    }catch(exception){
      console.log("exception in fetching search result.",exception);
      return null;
    } finally{
      this.universalService.showLoader = false;   
    }
  }

  async getCaptcha(){
    this.universalService.showLoader= true;
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["msgCallLogURL"] +  ENV_CONFIG.commonUrls["captcha"]
    // let param = {"groupKey" : groupKey}
    try {
      var result = await this.dashboardImplementation.getCaptcha(url);
      return result;
    } catch (exc) {
      this.universalService.showLoader= false;
      return null;
    }
  }

  async submitBannerAction(name,email,phone,company,captcha,requirement,encCaptcha,size){
    if(requirement == undefined){
      requirement = ''
    }
    this.universalService.showLoader= true;
    let params ={
      "contactName": name, 
      "companyName": company, 
      "mobileNumber": phone, 
      "emailId": email, 
      "companySize": size, 
      "queryText": requirement, 
      "clearCaptcha": captcha, 
      "encCaptchaData": encCaptcha
    }
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["msgCallLogURL"] +  ENV_CONFIG.commonUrls["contactSales"];
    // let param = {"groupKey" : groupKey}
    try {
      var result = await this.dashboardImplementation.submitBannerAction(url,params);
      return result;
    } catch (exc) {
      this.universalService.showLoader= false;
      return exc;
    }
  }

  async getAllTeams(isPagination,pageNo=1) {
    if(this.universalService.allTeamsFoldersArray.length > 1){
      return;
    }
    this.universalService.showLoader= true;
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["admncURL"] + ENV_CONFIG["commonUrls"]["getAllTeams"];
    if(isPagination){
      url = url + "?page=" +  pageNo + "&pageSize=50";
    }else{
      url = url + "?page=" +  pageNo + "&pageSize=1000";
    }
    this.dashboardImplementation.setHandler(this.globalService);
    try {
      var result = await this.dashboardImplementation.getAllTeams(url);
      return result;
    } catch (exc) {
      this.universalService.showLoader= false;
      this.loggerService.log("exception handled for create team folder", exc);
      return null;
    }
  }
}